export enum SignUpRedirectType {

    Client = "client",
    Profit = "PROFIT_RESPONSE",
    ThankYouPage = "thank_you_page",
    AppsFlyer = "apps_flyer",
}
